import { useEffect, useState } from 'react';
import { ScreenSize } from 'glints-aries';

import { useMediaQuery } from './useMediaQuery';

export const regularScreenSizes = ['desktop', 'tablet', 'mobile'] as const;

export const useIsMobile = (): boolean => {
  const isMobileScreen =
    useMediaQuery(`(max-width: ${ScreenSize.mobileL}px)`) ?? false;

  const [isMobile, setIsMobile] = useState(isMobileScreen);

  useEffect(() => {
    setIsMobile(isMobileScreen);
  }, [isMobileScreen]);

  return isMobile;
};
